module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "Toc_Link3"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CN"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_Toc_Link3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "CT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_Toc_Link3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("DEAR BABY")])])]), _vm._v(" "), _c('p', {
    staticClass: "CO-2"
  }, [_vm._v("When Leonie’s pregnancy became visible, her mother, Albiana, moved to Los Angeles to find a place for Leonie to live until the baby was born. Leonie soon followed, and in time her sister Florence joined them. At first Leonie and Albiana lived on East First Street in downtown Los Angeles. From there the eight-months-pregnant Leonie wrote to Catherine Bunnell on October 30, 1904, that she was busy sewing and reading and that their home had a garden with roses and vegetables and a view of a green cemetery and of “hills and cottages and gardens set off against the far away mountains like a picture hung on the wall before you.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter2-1",
      "id": "cha-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" Of Yone she wrote: “It may be I shall not see him again. I have a fancy as if he were a bird that flew through my room and is vanished.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX-2"
  }, [_vm._v("Her abandonment pained Leonie more than she would admit. Years later, in a letter to her daughter Ailes, who was in despair over a failed love affair, Leonie revealed how much she had suffered at the loss of a love: “One of the strangest phenomena of life is a sudden violent love affair … they come and go—leaving the poor victim powerless to keep themselves … Then too—one idealizes the beloved beyond all semblance of fact—& when disappointment & disillusion come, life is too terrible—one hardly has the strength to go on. I know only too well. What an ecstasy of joy—being in love brings—but it is as unstable and evanescent as the froth of champagne.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter2-2",
      "id": "cha-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "TXS-2"
  }, [_vm._v("Isamu Noguchi was born on November 17, 1904, at the Los Angeles County Hospital, a charity hospital, which was all Leonie could afford. When she registered she gave her name as “Mrs. Yone Noguchi.” Ten days later the headline of an article in the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Los Angeles Herald")]), _vm._v(" ran: “Yone Noguchi’s Babe Pride of Hospital. White Wife of Author Presents Husband With Son.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter2-3",
      "id": "cha-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" A photograph showed the infant Isamu swaddled in the arms of a hospital nurse. His eyes seem to look out at the world with wonder. The text read:")]), _vm._v(" "), _c('p', {
    staticClass: "EX-2"
  }, [_vm._v("“Kawaii Kota ["), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("sic")]), _vm._v("],” meaning dear baby, are the words which Yone Noguchi, the author of “The American Diary of a Japanese Girl,” begins his book, and out at the county hospital the story of another little life has begun, and the little son which has been born to the wife of the author and poet, is just such another baby as the one described by him in the first page of his book.")]), _vm._v(" "), _c('p', {
    staticClass: "EXI-1"
  }, [_vm._v("The young man gives promise of being in every way a fine specimen of the kind that is holding the attention of the whole civilized world. [The Russo-Japanese War of 1904–05 was making headlines at this time.] In spite of the fact that baby was born under the flag of Uncle Sam and that his mother is an American woman, of the blue eyed type, he has not a single trace of anything but Japanese and the hair and eyes are as black as his father’s ever were. Out at the hospital he is quite the center of attraction and the nurses have endowed him with the name of “Bobbie” for lack of a better one. He is exhibited on all occasions and there is no treat the son of the illustrious poet can not have for the asking."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter2-4",
      "id": "cha-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "STNI-1"
  }, [_vm._v("After Isamu was born, Leonie and her mother moved to a tent village outside of Pasadena where, with money from Florence’s savings from her salary at the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Encyclopedia Britannica")]), _vm._v(", they purchased a plot of land and lived in a tent. For Albiana, Leonie arranged for the construction of a one-bedroom shack. Leaving Isamu in the care of her mother, Leonie found work first as a typist at the Los Angeles Chamber of Commerce and then as a stenographer and assistant bookkeeper at an iron foundry."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter2-5",
      "id": "cha-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" Years later Noguchi mused about his birth: “I suspect that I was an accident, unexpected and inconvenient.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter2-6",
      "id": "cha-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" But in her letters to Catherine Bunnell, Leonie spoke adoringly of the child she called “baby” while waiting for Yone to give him a Japanese name. On New Year’s Day 1905 she wrote to thank Catherine for her Christmas presents: “Baby has tried on his shoes and he thinks they will fit nicely about the time he gets ready to wear shoes. At present he keeps his feet tucked away in his petticoat. They are very pretty (feet and shoes) Wish I had a decent picture to send. That newspaper picture [in the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Los Angeles Herald")]), _vm._v("] is rank injustice. He’s a sweet pretty boy. Don’t know just who he looks like. At first he had a decided resemblance to his daddy, but it’s wearing off. He has a funny little Irish-Japanese smile that would do your heart good to see.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter2-7",
      "id": "cha-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX-2"
  }, [_vm._v("In April 1905 Leonie received the first (extant) letter from Yone since he had returned to Japan, indeed, the first letter since his declaration of marriage. He began: “I received your letter of March 10th and I am glad Baby is all right.” He then launched into the one subject that seemed to matter to him: her work on his manuscripts and her efforts to sell his writings. Yone sent Leonie articles to be edited and she sent them on to be published by their friend Frank Putnam. “And you take some money out, and send me the rest,” he instructed."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter2-8",
      "id": "cha-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" Often in his correspondence with Leonie, he complained about being poor.")]), _vm._v(" "), _c('p', {
    staticClass: "TX-2"
  }, [_vm._v("Yone’s April letter to Leonie does not mention his personal travails. He had hoped that Ethel would arrive in Japan in March and that they would be married. But a female reporter for the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Los Angeles Herald")]), _vm._v(" told Ethel about Yone’s affair with Leonie and Isamu’s birth. Ethel was outraged. In an undated letter to Stoddard, she wrote: “I haven’t been able—literally to write a sane line since it all happened. Her name is Leonie Gilmour or Gilman and I believe she goes as Mrs. Noguchi … She says—you know—that Yone lived with her the year—all that year he was writing to me & we were engaged—she says he was married to her all that time. I heard from him a few weeks ago & he says he lived with her one week only & that she lies. I do not think she lies … You can give me your impression at least. But it makes no difference—there is the child—his treatment of that woman.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter2-9",
      "id": "cha-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX-2"
  }, [_vm._v("No sooner had Ethel broken off their engagement than Yone turned to Leonie and asked her to come to Japan. His April letter said: “Of course, you know, Leonie, you are wiser. You do what you think right and good. I cannot pursuade ["), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("sic")]), _vm._v("] you, this matter especially you know.” Leonie’s reaction to the news of Yone’s involvement with Ethel was forgiving. Meanwhile, Yone wrote to Stoddard as if the crisis caused by the women finding out about each other was trivial: “Did Ethel write to you about the Los Angel’s ["), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("sic")]), _vm._v("] woman? It is not so black with me as you may fancy. Don’t trouble yourself with that matter, pray. I will settle it myself. And in fact it was all settled—a long time ago.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter2-10",
      "id": "cha-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" He begged Stoddard to come to Japan, assuring him that all he would have to pay for was his steamship passage. His house at 81 Hisakata, Koishikawa, was, he said, about a mile from the center of Tokyo. It was surrounded by trees and flowers and had two servants. “Will you come over? I will treat you like a Lord … no money is necessary, after your arrival in Japan I make money enough for myself, and besides for somebody else … come over here, and live with me—can’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX-2"
  }, [_vm._v("Leonie’s letters to Catherine suggest that her longing for Yone was counterbalanced by her delight in motherhood. “First Baby is growing fast and fair. I named him Yosemite, but his papa has not condescended to set the seal of his august approval thereon. He says: ‘I will send some good name soon. I am pondering upon it.’ And he still continues to allude to his lordship as IT.” The baby, she told Catherine, could walk and “say whole lots of things. He has a lively temper. When he gets mad he jumps up and down so hard I’m afraid he’ll injure his feet.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter2-11",
      "id": "cha-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "413",
      "src": "images/2.2_fmt.jpeg",
      "width": "503"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "CAP-2"
  }, [_vm._v("Isamu, aged about nine months, in his native California")]), _vm._v(" "), _c('p', {
    staticClass: "TXS-2"
  }, [_vm._v("That fall, Leonie planted a vegetable garden. A photograph of Isamu at about age one shows him standing near a tomato plant and wearing a dress that reaches his ankles but exposes his bare feet."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter2-12",
      "id": "cha-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" The fourteen-month-old Isamu was, Leonie wrote to Catherine, a “wonderful conversationalist, singer, actor, storyteller, climber, dancer, jumper, and general stirrer-up of things.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter2-13",
      "id": "cha-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" Time spent at her desk, she said, had been productive. “The "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("National Magazine")]), _vm._v(" printed the third of the series of my Mirabel and Dousabel stories this month. I wrote another a few days ago which I like better than the others.” Meanwhile the correspondence between Yone and Leonie grew more heated as Yone alternated between urging her to join him in Japan and dissuading her from coming, usually because of his lack of money. In February 1906, Leonie came to a decision: she and “Baby” would be better off staying in California.")]), _vm._v(" "), _c('p', {
    staticClass: "LT-2"
  }, [_vm._v("Listen! America is a good country, California in particular. Baby is well. He is happy. Tho’ we be poor, he does not suffer from it. Maybe our way of living is not quite civilized—We live in a tent, where rains and wind come in at will—Baby has no shoes on his feet. He runs free as a squirrel on the hillside. Does it matter, our way of life? Roses are glowing on his cheeks. We built a little California house of one room beside the tent. There my mother lives. And there I took Baby in on the day it was finished. He was like a caged bird eagerly looking to door and windows for a way to escape … And education. Education is free here. I do not think much of “school” myself. I could myself teach him everything he would learn in school."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter2-14",
      "id": "cha-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "STXS"
  }, [_vm._v("Leonie acknowledged that as far as the aesthetic side of life Japan might have more to offer, but insisted that Isamu would do just as well in an American art school. She was concerned that if she and Isamu lived in Japan, Yone’s work would suffer:")]), _vm._v(" "), _c('p', {
    staticClass: "LT-2"
  }, [_vm._v("But how about your poetry? Where will you find it? In business? In the crowding cares and responsibilities? In the companionship of a wife you "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("do not love")]), _vm._v("? You shut love out of your life—human love, which is also divine. Why? Because Frank Putnam thinks you should? Because of awakened thoughts of responsibility toward your boy? Maybe you think you will make amends for the past. Past is past. You cannot "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("amend")]), _vm._v(" it. Maybe you think we, Baby and I, need you. We do not.")]), _vm._v(" "), _c('p', {
    staticClass: "LTI"
  }, [_vm._v("Therefore I think it better we live apart. If I have chance to have work in Southern Japan someday I will come. And you can see Baby all you like. And we will have proper separation when you get ready—and you will remarry according to your better and riper judgment. Baby and I have each other to love. Yes, that’s better."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter2-15",
      "id": "cha-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "STX-2"
  }, [_vm._v("Despite her decision, Leonie was ambivalent. She wrote to Frank Putnam: “Honestly I do love Yone … simply I wish to do what is the very best thing and for once in my life I believe I have decided wisely. It is a relief to have a thing definitely decided anyway. Really I am not ‘good enough’ for him.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter2-16",
      "id": "cha-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX-2"
  }, [_vm._v("Yone’s letters to Leonie in the following months reveal his diminishing enthusiasm for her coming to Tokyo. “Is your decision firm like a rock?” he wrote on April 2. “I know that you are wise always. And Baby is too little, and I am afraid that he will soon turn to be a little Jap boy. I really think that California is a better place to educate one and raise aprightly ["), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("sic")]), _vm._v("] … I am glad Baby is doing nicely. He will be a great boy, I am sure.” Undisclosed in these letters is Yone’s new affair with one of his servants, the seventeen-year-old Matsuko Takeda, whom he would marry six years later after they already had several children together. Nonetheless, Yone continued to expect Leonie to serve as his American editor and agent.")]), _vm._v(" "), _c('p', {
    staticClass: "TX-2"
  }, [_vm._v("In the meantime, Leonie continued to write and submit her own stories to Putnam. To supplement her income she was “picking flowers for the market,” typing and revising a manuscript for a young Greek playwright, and “cudgeling my brain for thoughts upon the subject of ‘Engaged Girls’ in answer to a most polite request from ‘Good Housekeeping.’” The thirty-one-year-old Leonie concluded her letter to Putnam on a wistful note: “The days are flying away—carrying my youth, alas! Some gray hairs are shining among my brown.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter2-17",
      "id": "cha-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX-2"
  }, [_vm._v("Despite Yone’s dissuasion and Leonie’s April letter declaring that she would remain in California, Leonie reversed her decision that fall, and decided to go to Japan. She wrote to Stoddard on December 6 that she was going as soon as they had enough money. “I am going to make a little Japanese boy out of my son.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter2-18",
      "id": "cha-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" Yet she knew that Yone could not be counted on as a husband or father: “I quite agree with you,” she wrote to Putnam, “that poets—at least some of them—were not made for domestic uses. So I shall open the door of the cage as soon as I get over there.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter2-19",
      "id": "cha-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX-2"
  }, [_vm._v("Leonie’s decision to go to Japan may have been prompted by California’s change in attitude toward Japanese immigrants. Americans had been pro-Japanese during the Russo-Japanese war, but Japan’s postwar expansionism in China met with American disapproval, especially in California. Already in 1905 a law prohibiting marriage between Caucasians and “negroes” or “mulattoes” had been amended to include “Mongolians.” The influx of Japanese laborers incited angry protests in some San Francisco labor unions, and the press was full of alarmist talk of the “Yellow Peril.” In 1906 the San Francisco school board ordered the children of Japanese immigrants to attend segregated schools. California farmers established the Asiatic Exclusion League and orange growers around Pasadena set up signs saying that no Japanese or Chinese would be hired."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter2-20",
      "id": "cha-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" For a mother with fierce pride in her son, who wanted to protect him from the sting of racial prejudice, these changes were surely disheartening.")]), _vm._v(" "), _c('p', {
    staticClass: "TX-2"
  }, [_vm._v("The last letter to Putnam that Leonie posted in the United States was written on January 23, 1907. She said she planned to leave soon, but she was still “pegging away” at her typewriter, writing the sequel to what she called her “tent story,” which had been published in the December issue of "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("West Coast Magazine")]), _vm._v(" and was titled “A Little California House.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter2-21",
      "id": "cha-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" Isamu, she said, “talks wisely about going on a big ship on the great wa-wa to see Papa. If you ask him what is a ship he smiles knowingly or points to a shadowy corner, saying ‘see, cunning little ship!’ He has the art of never being surprised or taken unawares. The funniest thing about telling a funny story before him is that he always laughs loudly before you get to the point of the story.” About joining Yone in Tokyo, she said: “Am I glad or sorry? Really, I don’t know. Call no man happy until he is dead … Yone’s letters are ominous, to say the least. He warns me not to bring any ‘dreams’ with me. Oh, well, I am tired of trying to do anything with him. I guess Baby Bob and I will take care of each other.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecf59e72","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter2.vue
// module id = 78
// module chunks = 0